export default __webpack_public_path__ + "static/media/client19.39471347.png";